import SoldInformation from './SoldInformation';
import BankruptcyInformation from './BankruptcyInformation';
import ClosedInformation from './ClosedInformation';
import MovedInformation from './MovedInformation';

let BusinessStatusInput = {};

BusinessStatusInput['sold'] = <SoldInformation />;
BusinessStatusInput['bankrupt'] = <BankruptcyInformation />;
BusinessStatusInput['closed'] = <ClosedInformation />;
BusinessStatusInput['moved'] = <MovedInformation />;

export default BusinessStatusInput;
